export default {"src":"https://web.cdn.greenlight.com/2.1283.0/_next/static/media/ellipse.294f6c2c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};